import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Leaf } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) return setError("Password must be at least 6 characters.");
    setBusy(true);
    const res = await register(email, password, name);
    setBusy(false);
    if (!res.ok) return setError(res.error);
    const next = new URLSearchParams(loc.search).get("next") || "/unlock";
    nav(next);
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20 md:py-24">
      <div className="text-center">
        <Leaf className="w-6 h-6 text-[var(--forest)] mx-auto" strokeWidth={1.5} />
        <p className="label-eyebrow mt-3">Create account</p>
        <h1 className="font-serif text-4xl md:text-5xl mt-2">Begin the field study.</h1>
        <p className="text-sm text-[var(--ink-soft)] mt-3">An account holds your $4 unlock forever.</p>
      </div>
      <form onSubmit={submit} className="mt-10 space-y-7">
        <div>
          <label className="label-eyebrow">Name (optional)</label>
          <input data-testid="register-name-input" className="field mt-2" value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div>
          <label className="label-eyebrow">Email</label>
          <input data-testid="register-email-input" className="field mt-2" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div>
          <label className="label-eyebrow">Password (6+ chars)</label>
          <input data-testid="register-password-input" className="field mt-2" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        {error && <p data-testid="register-error" className="text-sm text-[var(--terracotta)]">{error}</p>}
        <button data-testid="register-submit-btn" type="submit" disabled={busy} className="btn-primary w-full justify-center">
          {busy ? "Creating…" : "Create account"}
        </button>
      </form>
      <p className="mt-6 text-sm text-center text-[var(--ink-soft)]">
        Already have an account? <Link data-testid="register-to-login" to="/login" className="underline underline-offset-4 decoration-[var(--terracotta)]">Sign in</Link>
      </p>
    </div>
  );
}
